<template>
  <div style="height: calc(100vh - 88px)">
    <iframe frameborder="0" width="100%" height="100%" :src="src"></iframe>
  </div>
</template>

<script>
  export default {
    name: "Mall",
    data() {
      return {
        domain: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "") + '/esaleb-mall-pc-admin-ui',
        src: ''
      }
    },
    created() {
      this.src = this.$variable.getMallAddress() + '/#/freightAdmin'
    }
  }
</script>

<style scoped>

</style>